<div class="container-fluid">
  <div class="row">
    <div *ngIf="loading">
      <div class="loading-text loadStyle">
        Loading...
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
